module.exports = __webpack_public_path__ + "img/car_shina2_45.6074baec.jpg";